import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LazySize from 'src/components/LazySize';
import ProgressPlaceholder from 'src/images/progressPlaceholder.png';

// ----------------------------------------------------------------------

LogoAvatar.propTypes = {
  className: PropTypes.string
};

function LogoAvatar({ className, ...other }) {
  const { user } = useAuth();

  return (
    <LazySize
      key={`${user._id}-${user.companyLogo}`}
      src={user.companyLogo || ProgressPlaceholder}
      sx={{
        width: 40,
        height: 40,
        borderRadius: 40,
        border: 'solid 1px #e4e8eb'
      }}
    />
  );
}

export default LogoAvatar;
